import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import './DTViewer.css';

function DTNuevo({ onClose, onSaveDT }) {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: null, y: null });
  const [openMenu, setOpenMenu] = useState(null);
  const [activeTab, setActiveTab] = useState('DT');
  const dragOffset = useRef({ x: 0, y: 0 });
  const dialogRef = useRef(null);

  const [form, setForm] = useState({
    aduanaCodigo: '', aduanaNombre: '',
    numeroViaje: '', fechaSalida: '', fechaLlegada: '', horaLlegada: '',
    numeroRegistro: '', numeroRegistro2: '',
    numeroReferenciaDT: '', tipoDT: '', tipoDTDesc: '', uso: '',
    ultimaDescarga: '', dtLinea: '', documentoPrevio: '', ucr: '',
    lugarEmbarqueCod: '', lugarEmbarqueNombre: '',
    lugarDesembarqueCod: '', lugarDesembarqueNombre: '',
    transportistaCod: '', transportistaNombre: '',
    transportistaDireccion: '', transportistaRef: '',
    exportadorNombre: '', exportadorDireccion: '',
    consignatarioNombre: '', notificarNombre: '',
    transporteModo: '', transporteModoDesc: '',
    transporteNombre: '', transporteNacionalidad: '', transporteNacionalidadDesc: '',
    // Detalles mercancías
    contenedores: '', codigoEmbalaje: '', codigoEmbalajeDesc: '',
    estado: '', numDocDesconsolida: '0', marcasNum: '',
    paquetesManifestados: '', paquetesRestantes: '',
    pesoBrutoManifestado: '', pesoBrutoRestante: '', volumenMC: '',
    descripcionMercancias: '',
    // Localizar
    localizarCod: '',
    // Valor Declarado
    indPC: '', montoMonedaFlete: '',
    valorAduanas: '', valorTransporte: '', valorSeguro: '',
    numeroPrecintos: '', marcasPrecintos: '', emisor: '',
    informacion: '',
    // Transporte adicional
    transito: '', referenciaDocTransito: '',
    transbordo: '', referenciaDocTransbordo: '',
    transportistaBottom: '',
  });

  const [validationErrors, setValidationErrors] = useState({});

  // Contenedores tab data - input row (top) and added rows (bottom)
  const [containerInput, setContainerInput] = useState(
    { numero: 'MRSU1647490', numPaq: '', tipoCont: '', vli: '', numPrecintos: '', emisor: '', pesoVacio: '', pesoMercancia: '' }
  );
  const [addedContainers, setAddedContainers] = useState([]);

  const handleContainerInputChange = (field) => (e) => {
    setContainerInput({ ...containerInput, [field]: e.target.value });
  };

  const handleAddContainer = () => {
    // Only add if at least numero is filled
    if (containerInput.numero.trim()) {
      setAddedContainers([...addedContainers, { ...containerInput }]);
      setContainerInput({ numero: '', numPaq: '', tipoCont: '', vli: '', numPrecintos: '', emisor: '', pesoVacio: '', pesoMercancia: '' });
    }
  };

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
    // Clear error for this field when user types
    if (validationErrors[field]) {
      setValidationErrors((prev) => { const n = { ...prev }; delete n[field]; return n; });
    }
  };

  // Fields excluded from validation (Valor Declarado y Detalle Precintos + Transporte bottom)
  const excludedFields = [
    'indPC', 'montoMonedaFlete', 'valorAduanas', 'valorTransporte', 'valorSeguro',
    'numeroPrecintos', 'marcasPrecintos', 'emisor', 'informacion',
    'transito', 'referenciaDocTransito', 'transbordo', 'referenciaDocTransbordo', 'transportistaBottom',
    'transportistaDireccion', 'exportadorDireccion'
  ];

  // Required fields = all form fields minus excluded
  const requiredFields = Object.keys(form).filter(f => !excludedFields.includes(f));

  const handleValidate = () => {
    const errors = {};
    requiredFields.forEach((field) => {
      if (!form[field] || !form[field].toString().trim()) {
        errors[field] = true;
      }
    });
    setValidationErrors(errors);
    if (Object.keys(errors).length > 0) {
      setActiveTab('DT');
    }
  };

  const handleSave = () => {
    // Build a result-row object from the form data
    const dt = {
      codigoAduana: form.aduanaCodigo,
      numeroViaje: form.numeroViaje,
      fechaSalida: form.fechaSalida,
      referenciaDT: form.numeroReferenciaDT,
      referenciaDTPadre: '',
      tipo: form.tipoDT + ' ' + form.tipoDTDesc,
      uso: form.uso,
      lugarEmbarque: form.lugarEmbarqueCod,
      lugarDesembarque: form.lugarDesembarqueCod,
      estatus: 'NUE',
      indicadorDividir: '',
      nombreConsignatario: form.consignatarioNombre,
      // Keep the full form for viewer
      _fullForm: { ...form },
    };
    if (onSaveDT) onSaveDT(dt);
    onClose();
  };

  const fieldStyle = (field) => validationErrors[field] ? { border: '2px solid #cc0000', background: '#fff0f0' } : {};

  const handleMouseDown = (e) => {
    if (dialogRef.current) {
      const rect = dialogRef.current.getBoundingClientRect();
      dragOffset.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
      setIsDragging(true);
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({ x: e.clientX - dragOffset.current.x, y: e.clientY - dragOffset.current.y });
    }
  };

  const handleMouseUp = () => setIsDragging(false);

  const style = position.x !== null
    ? { left: position.x, top: position.y, transform: 'none' }
    : {};

  const menus = [
    { label: 'Archivo', items: ['Guardar', 'Cerrar'] },
    { label: 'Editar', items: ['Copiar', 'Pegar'] },
    { label: 'Ver', items: ['Actualizar'] },
    { label: 'Ayuda', items: ['Acerca de'] },
  ];

  return ReactDOM.createPortal(
    <div className="dt-viewer-overlay" onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
      <div className="dt-viewer-window" ref={dialogRef} style={style}>
        {/* Barra de título */}
        <div className="dt-viewer-titlebar" onMouseDown={handleMouseDown}>
          <span className="dt-viewer-title">D/T - Nuevo [n/a]</span>
          <button className="dt-viewer-close" onClick={onClose}>×</button>
        </div>

        {/* Menú */}
        <div className="dt-viewer-menubar">
          {menus.map((menu, idx) => (
            <div className="dt-viewer-menu-item" key={menu.label}>
              <button
                className={`dt-viewer-menu-btn ${openMenu === idx ? 'active' : ''}`}
                onClick={() => setOpenMenu(openMenu === idx ? null : idx)}
                onMouseEnter={() => openMenu !== null && setOpenMenu(idx)}
              >
                {menu.label}
              </button>
              {openMenu === idx && (
                <div className="dt-viewer-dropdown">
                  {menu.items.map((item) => (
                    <button
                      className="dt-viewer-dropdown-item"
                      key={item}
                      onClick={() => {
                        if (item === 'Cerrar') onClose();
                        if (item === 'Guardar') handleSave();
                        setOpenMenu(null);
                      }}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Barra de iconos */}
        <div className="dt-viewer-toolbar">
          <button className="dt-toolbar-btn" title="Verificar campos" onClick={handleValidate}>👁</button>
          <button className="dt-toolbar-btn" title="Guardar" onClick={handleSave}>💾</button>
          <div className="dt-toolbar-sep"></div>
          <button className="dt-toolbar-btn dt-toolbar-xml" title="XML">
            <span style={{color:'#1a6fb5',fontWeight:'bold',fontSize:'10px'}}>XML</span>
          </button>
          <button className="dt-toolbar-btn dt-toolbar-xml" title="XML Importar">
            <span style={{color:'#cc0000',fontWeight:'bold',fontSize:'10px'}}>XML</span>
          </button>
          <div className="dt-toolbar-sep"></div>
          <button className="dt-toolbar-btn" title="Imprimir">🖨</button>
          <button className="dt-toolbar-btn" title="Agregar" onClick={handleAddContainer}>➕</button>
          <div className="dt-toolbar-sep"></div>
          <button className="dt-toolbar-btn" title="Ayuda">❓</button>
        </div>

        {/* Contenido scrollable */}
        <div className="dt-viewer-content">
          {activeTab === 'DT' && (<>
          {/* Banner */}
          <div className="dt-viewer-banner">
            <span>Manifiesto - Documento de transporte</span>
          </div>

          {/* Aduana */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Aduana de salida / llegada</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '80px' }}>
                <input className="dt-viewer-input" style={fieldStyle('aduanaCodigo')} value={form.aduanaCodigo} onChange={handleChange('aduanaCodigo')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <input className="dt-viewer-input" style={fieldStyle('aduanaNombre')} value={form.aduanaNombre} onChange={handleChange('aduanaNombre')} />
              </div>
            </div>
          </fieldset>

          {/* Información General */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Información General</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Número de viaje</label>
                <input className="dt-viewer-input" style={fieldStyle('numeroViaje')} value={form.numeroViaje} onChange={handleChange('numeroViaje')} />
              </div>
              <div className="dt-viewer-field">
                <label>Fecha de salida</label>
                <input className="dt-viewer-input" style={fieldStyle('fechaSalida')} value={form.fechaSalida} onChange={handleChange('fechaSalida')} />
              </div>
              <div className="dt-viewer-field">
                <label>Fecha de llegada</label>
                <input className="dt-viewer-input" style={fieldStyle('fechaLlegada')} value={form.fechaLlegada} onChange={handleChange('fechaLlegada')} />
              </div>
              <div className="dt-viewer-field" style={{ width: '90px' }}>
                <label>Hora de llegada</label>
                <input className="dt-viewer-input" style={fieldStyle('horaLlegada')} value={form.horaLlegada} onChange={handleChange('horaLlegada')} />
              </div>
              <div className="dt-viewer-field">
                <label>Número de registro</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={fieldStyle('numeroRegistro')} value={form.numeroRegistro} onChange={handleChange('numeroRegistro')} />
                  <input className="dt-viewer-input" style={{ width: '50px', ...fieldStyle('numeroRegistro2') }} value={form.numeroRegistro2} onChange={handleChange('numeroRegistro2')} />
                </div>
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Número referencia DT</label>
                <input className="dt-viewer-input" style={fieldStyle('numeroReferenciaDT')} value={form.numeroReferenciaDT} onChange={handleChange('numeroReferenciaDT')} />
              </div>
              <div className="dt-viewer-field">
                <label>Tipo DT</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '50px', ...fieldStyle('tipoDT') }} value={form.tipoDT} onChange={handleChange('tipoDT')} />
                  <input className="dt-viewer-input" style={{ flex: 1, ...fieldStyle('tipoDTDesc') }} value={form.tipoDTDesc} onChange={handleChange('tipoDTDesc')} />
                </div>
              </div>
              <div className="dt-viewer-field" style={{ width: '50px' }}>
                <label>Uso</label>
                <input className="dt-viewer-input" style={fieldStyle('uso')} value={form.uso} onChange={handleChange('uso')} />
              </div>
              <div className="dt-viewer-field" style={{ width: '100px' }}>
                <label>Última descarga</label>
                <input className="dt-viewer-input" style={fieldStyle('ultimaDescarga')} value={form.ultimaDescarga} onChange={handleChange('ultimaDescarga')} />
              </div>
              <div className="dt-viewer-field" style={{ width: '60px' }}>
                <label>DT línea</label>
                <input className="dt-viewer-input" style={fieldStyle('dtLinea')} value={form.dtLinea} onChange={handleChange('dtLinea')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Documento previo</label>
                <input className="dt-viewer-input" style={fieldStyle('documentoPrevio')} value={form.documentoPrevio} onChange={handleChange('documentoPrevio')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>UCR</label>
                <input className="dt-viewer-input" style={fieldStyle('ucr')} value={form.ucr} onChange={handleChange('ucr')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Lugar de embarque</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '60px', ...fieldStyle('lugarEmbarqueCod') }} value={form.lugarEmbarqueCod} onChange={handleChange('lugarEmbarqueCod')} />
                  <input className="dt-viewer-input" style={{ flex: 1, ...fieldStyle('lugarEmbarqueNombre') }} value={form.lugarEmbarqueNombre} onChange={handleChange('lugarEmbarqueNombre')} />
                </div>
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Lugar de desembarque</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '60px', ...fieldStyle('lugarDesembarqueCod') }} value={form.lugarDesembarqueCod} onChange={handleChange('lugarDesembarqueCod')} />
                  <input className="dt-viewer-input" style={{ flex: 1, ...fieldStyle('lugarDesembarqueNombre') }} value={form.lugarDesembarqueNombre} onChange={handleChange('lugarDesembarqueNombre')} />
                </div>
              </div>
            </div>
          </fieldset>

          {/* Transportista y Exportador */}
          <div className="dt-viewer-row-sections">
            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Transportista</legend>
              <div className="dt-viewer-text-block">
                <input className="dt-viewer-input" style={fieldStyle('transportistaCod')} value={form.transportistaCod} onChange={handleChange('transportistaCod')} />
                <textarea className="dt-viewer-textarea" rows={4} style={fieldStyle('transportistaNombre')} value={form.transportistaNombre} onChange={handleChange('transportistaNombre')} />
                <div className="dt-viewer-row" style={{ marginTop: '4px' }}>
                  <div className="dt-viewer-field" style={{ flex: 1 }}>
                    <label>Transportista</label>
                    <input className="dt-viewer-input" style={fieldStyle('transportistaRef')} value={form.transportistaRef} onChange={handleChange('transportistaRef')} />
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Exportador/Embarcador</legend>
              <div className="dt-viewer-text-block">
                <textarea className="dt-viewer-textarea" rows={5} style={fieldStyle('exportadorNombre')} value={form.exportadorNombre} onChange={handleChange('exportadorNombre')} />
              </div>
            </fieldset>
          </div>

          {/* Transporte */}
          <div className="dt-viewer-banner">
            <span>Transporte</span>
          </div>
          <fieldset className="dt-viewer-fieldset">
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '50px' }}>
                <label>Modo</label>
                <input className="dt-viewer-input" style={fieldStyle('transporteModo')} value={form.transporteModo} onChange={handleChange('transporteModo')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>&nbsp;</label>
                <input className="dt-viewer-input" style={fieldStyle('transporteModoDesc')} value={form.transporteModoDesc} onChange={handleChange('transporteModoDesc')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Nombre</label>
                <input className="dt-viewer-input" style={fieldStyle('transporteNombre')} value={form.transporteNombre} onChange={handleChange('transporteNombre')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '50px' }}>
                <label>Nacionalidad</label>
                <input className="dt-viewer-input" style={fieldStyle('transporteNacionalidad')} value={form.transporteNacionalidad} onChange={handleChange('transporteNacionalidad')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>&nbsp;</label>
                <input className="dt-viewer-input" style={fieldStyle('transporteNacionalidadDesc')} value={form.transporteNacionalidadDesc} onChange={handleChange('transporteNacionalidadDesc')} />
              </div>
            </div>
          </fieldset>

          {/* Consignatario y Notificar */}
          <div className="dt-viewer-row-sections">
            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Notificar</legend>
              <div className="dt-viewer-text-block">
                <textarea className="dt-viewer-textarea" rows={4} style={fieldStyle('notificarNombre')} value={form.notificarNombre} onChange={handleChange('notificarNombre')} />
              </div>
            </fieldset>
            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Consignatario</legend>
              <div className="dt-viewer-text-block">
                <textarea className="dt-viewer-textarea" rows={4} style={fieldStyle('consignatarioNombre')} value={form.consignatarioNombre} onChange={handleChange('consignatarioNombre')} />
              </div>
            </fieldset>
          </div>

          {/* Detalles mercancías */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Detalles mercancías</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '80px' }}>
                <label>Contenedores</label>
                <input className="dt-viewer-input" style={fieldStyle('contenedores')} value={form.contenedores} onChange={handleChange('contenedores')} />
              </div>
              <div className="dt-viewer-field">
                <label>Código de Embalaje</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '40px', ...fieldStyle('codigoEmbalaje') }} value={form.codigoEmbalaje} onChange={handleChange('codigoEmbalaje')} />
                  <input className="dt-viewer-input" style={{ flex: 1, ...fieldStyle('codigoEmbalajeDesc') }} value={form.codigoEmbalajeDesc} onChange={handleChange('codigoEmbalajeDesc')} />
                </div>
              </div>
              <div className="dt-viewer-field">
                <label>Estado</label>
                <input className="dt-viewer-input" style={fieldStyle('estado')} value={form.estado} onChange={handleChange('estado')} />
              </div>
              <div className="dt-viewer-field">
                <label>Número de documentos desconsolida.</label>
                <input className="dt-viewer-input" style={fieldStyle('numDocDesconsolida')} value={form.numDocDesconsolida} onChange={handleChange('numDocDesconsolida')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Marcas y Núm.</label>
                <input className="dt-viewer-input" style={fieldStyle('marcasNum')} value={form.marcasNum} onChange={handleChange('marcasNum')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Paquetes manifestados</label>
                <input className="dt-viewer-input" style={fieldStyle('paquetesManifestados')} value={form.paquetesManifestados} onChange={handleChange('paquetesManifestados')} />
              </div>
              <div className="dt-viewer-field">
                <label>Paquetes restantes</label>
                <input className="dt-viewer-input" style={fieldStyle('paquetesRestantes')} value={form.paquetesRestantes} onChange={handleChange('paquetesRestantes')} />
              </div>
              <div className="dt-viewer-field">
                <label>Peso bruto manifestado</label>
                <input className="dt-viewer-input" style={fieldStyle('pesoBrutoManifestado')} value={form.pesoBrutoManifestado} onChange={handleChange('pesoBrutoManifestado')} />
              </div>
              <div className="dt-viewer-field">
                <label>Peso bruto restante</label>
                <input className="dt-viewer-input" style={fieldStyle('pesoBrutoRestante')} value={form.pesoBrutoRestante} onChange={handleChange('pesoBrutoRestante')} />
              </div>
              <div className="dt-viewer-field">
                <label>Volúmen (MC)</label>
                <input className="dt-viewer-input" style={fieldStyle('volumenMC')} value={form.volumenMC} onChange={handleChange('volumenMC')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Descripción de las mercancías</label>
                <textarea className="dt-viewer-textarea" rows={3} style={fieldStyle('descripcionMercancias')} value={form.descripcionMercancias} onChange={handleChange('descripcionMercancias')} />
              </div>
            </div>
          </fieldset>

          {/* Localizar */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Localizar</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <input className="dt-viewer-input" style={fieldStyle('localizarCod')} value={form.localizarCod} onChange={handleChange('localizarCod')} />
              </div>
            </div>
          </fieldset>

          {/* Valor Declarado y Detalle Precintos */}
          <div className="dt-viewer-banner">
            <span>Valor Declarado y Detalle Precintos</span>
          </div>
          <fieldset className="dt-viewer-fieldset">
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Ind. P/C</label>
                <input className="dt-viewer-input" value={form.indPC} onChange={handleChange('indPC')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Monto y moneda flete</label>
                <input className="dt-viewer-input" value={form.montoMonedaFlete} onChange={handleChange('montoMonedaFlete')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Valor en aduanas</label>
                <input className="dt-viewer-input" value={form.valorAduanas} onChange={handleChange('valorAduanas')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Valor transporte</label>
                <input className="dt-viewer-input" value={form.valorTransporte} onChange={handleChange('valorTransporte')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Valor seguro</label>
                <input className="dt-viewer-input" value={form.valorSeguro} onChange={handleChange('valorSeguro')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Número precintos</label>
                <input className="dt-viewer-input" value={form.numeroPrecintos} onChange={handleChange('numeroPrecintos')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Marcas</label>
                <input className="dt-viewer-input" value={form.marcasPrecintos} onChange={handleChange('marcasPrecintos')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Emisor</label>
                <input className="dt-viewer-input" value={form.emisor} onChange={handleChange('emisor')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Información</label>
                <input className="dt-viewer-input" value={form.informacion} onChange={handleChange('informacion')} />
              </div>
            </div>
          </fieldset>

          {/* Transporte (sección inferior) */}
          <div className="dt-viewer-banner">
            <span>Transporte</span>
          </div>
          <fieldset className="dt-viewer-fieldset">
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Tránsito</label>
                <input className="dt-viewer-input" value={form.transito} onChange={handleChange('transito')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Referencia doc.</label>
                <input className="dt-viewer-input" value={form.referenciaDocTransito} onChange={handleChange('referenciaDocTransito')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Transbordo</label>
                <input className="dt-viewer-input" value={form.transbordo} onChange={handleChange('transbordo')} />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Referencia doc.</label>
                <input className="dt-viewer-input" value={form.referenciaDocTransbordo} onChange={handleChange('referenciaDocTransbordo')} />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Transportista</label>
                <input className="dt-viewer-input" value={form.transportistaBottom} onChange={handleChange('transportistaBottom')} />
              </div>
            </div>
          </fieldset>
          </>)}

          {activeTab === 'Contenedores' && (
            <div className="dt-contenedores-tab">
              {/* Banner Contenedores */}
              <div className="dt-viewer-banner" style={{ marginBottom: '6px' }}>
                <span>D/T - Contenedores</span>
              </div>
              {/* Información Contenedor - tabla superior */}
              <fieldset className="dt-viewer-fieldset" style={{ marginBottom: '6px' }}>
                <legend style={{ color: '#cc0000' }}>Información Contenedor</legend>
                <div className="dt-cont-table-wrapper">
                  <table className="dt-cont-table">
                    <thead>
                      <tr>
                        <th>Número de contenedor</th>
                        <th>Núm. de paq.</th>
                        <th>Tipo Cont.</th>
                        <th>V.L.I</th>
                        <th>Número precintos</th>
                        <th></th>
                        <th>Emisor</th>
                        <th>Peso vacío</th>
                        <th>Peso de mercancía</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><input className="dt-cont-input" value={containerInput.numero} onChange={handleContainerInputChange('numero')} /></td>
                        <td><input className="dt-cont-input" value={containerInput.numPaq} onChange={handleContainerInputChange('numPaq')} /></td>
                        <td><input className="dt-cont-input" value={containerInput.tipoCont} onChange={handleContainerInputChange('tipoCont')} /></td>
                        <td><input className="dt-cont-input" value={containerInput.vli} onChange={handleContainerInputChange('vli')} /></td>
                        <td><input className="dt-cont-input" value={containerInput.numPrecintos} onChange={handleContainerInputChange('numPrecintos')} /></td>
                        <td></td>
                        <td><input className="dt-cont-input" value={containerInput.emisor} onChange={handleContainerInputChange('emisor')} /></td>
                        <td><input className="dt-cont-input" value={containerInput.pesoVacio} onChange={handleContainerInputChange('pesoVacio')} /></td>
                        <td><input className="dt-cont-input" value={containerInput.pesoMercancia} onChange={handleContainerInputChange('pesoMercancia')} /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </fieldset>

              {/* Tabla inferior */}
              <div className="dt-cont-table-wrapper dt-cont-lower">
                <table className="dt-cont-table">
                  <thead>
                    <tr>
                      <th>Número de contenedor</th>
                      <th>Núm. de paq.</th>
                      <th>Tipo Cont.</th>
                      <th>V.L.I</th>
                      <th>Marcas num.</th>
                      <th>Marcas num.</th>
                      <th>Emisor</th>
                      <th>Peso vacío</th>
                      <th>Peso de mercanc...</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addedContainers.length === 0 ? (
                      <tr className="dt-cont-empty-row"><td colSpan={9}>&nbsp;</td></tr>
                    ) : (
                      addedContainers.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.numero}</td>
                          <td>{row.numPaq}</td>
                          <td>{row.tipoCont}</td>
                          <td>{row.vli}</td>
                          <td></td>
                          <td></td>
                          <td>{row.emisor}</td>
                          <td>{row.pesoVacio}</td>
                          <td>{row.pesoMercancia}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Ship background */}
              <div className="dt-cont-ship-bg"></div>
            </div>
          )}

          {activeTab === 'Dividir' && (
            <div style={{ padding: '10px', color: '#666' }}>Dividir</div>
          )}
          {activeTab === 'Descargado' && (
            <div style={{ padding: '10px', color: '#666' }}>Descargado</div>
          )}
        </div>

        {/* Tabs inferiores */}
        <div className="dt-viewer-tabs">
          {['DT', 'Contenedores', 'Dividir', 'Descargado'].map((tab) => (
            <button
              key={tab}
              className={`dt-viewer-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default DTNuevo;
